export const $loading = require('@/services/Loading').default
export const $events = require('@/services/Events').default

export const loading$ = $loading
export const events$ = $events